import reduceMedias from 'utils/reduceMedias'
import { limit as fetchLimit } from 'consts'
import { mediaByNodeQuery, mediaSearchQuery } from 'utils/queries'

export default async ({ graphql, props, path, state }) => {
  try {
    const sortType = state.get('media.sortType')
    const listType = state.get('node.listType')
    const node = state.get('node.selectedNode.id')
    const fetchCount = state.get('media.fetchCount')
    const { limit = fetchCount || fetchLimit, loaded = 0, query = null } = props

    const mediaQuery = query
      ? mediaSearchQuery({ sortType, limit, skip: loaded, criteria: query })
      : mediaByNodeQuery({ sortType, limit, skip: loaded, node, listType })

    const result = await graphql.query(mediaQuery)

    const { count, medias } = result.mediaByNode
      ? result.mediaByNode
      : result.mediaBySearch

    const files = reduceMedias(medias)

    return path.loaded({
      files,
      total: count,
      loaded: count < loaded + limit ? count : loaded + limit,
      query
    })
  } catch (e) {
    return path.error(e)
  }
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/fetchMedia.js